import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from "reactstrap";
import { useTranslation } from "react-i18next";

const EditBonusModal = ({
  isOpen,
  toggle,
  onConfirm,
  isUpdating,
  bonusToEdit,
  editAmount,
  setEditAmount,
  editStartDate,
  setEditStartDate,
  editEndDate,
  setEditEndDate,
  editIsTaxable,
  setEditIsTaxable,
  backendError
}) => {
  const { t } = useTranslation();

  if (!bonusToEdit) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle}>
        <i className="fa fa-edit text-primary me-2"></i>
        {t("edit_bonus")} - {bonusToEdit.bonus?.name}
      </ModalHeader>
      
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          {backendError && (
            <div className="alert alert-danger">
              <i className="fa fa-exclamation-circle me-2"></i>
              {backendError}
            </div>
          )}

          <FormGroup>
            <Label for="editAmount">{t("amount")} *</Label>
            <Input
              type="number"
              id="editAmount"
              value={editAmount}
              onChange={(e) => setEditAmount(e.target.value)}
              placeholder={t("enter_amount")}
              min="0"
              step="0.01"
              required
              disabled={isUpdating}
            />
          </FormGroup>

          <FormGroup>
            <Label for="editStartDate">{t("start_date")} *</Label>
            <Input
              type="date"
              id="editStartDate"
              value={editStartDate}
              onChange={(e) => setEditStartDate(e.target.value)}
              required
              disabled={isUpdating}
            />
          </FormGroup>

          <FormGroup>
            <Label for="editEndDate">{t("end_date")}</Label>
            <Input
              type="date"
              id="editEndDate"
              value={editEndDate}
              onChange={(e) => setEditEndDate(e.target.value)}
              min={editStartDate}
              disabled={isUpdating}
            />
            <small className="text-muted">{t("optional_leave_empty_for_indefinite")}</small>
          </FormGroup>

          <FormGroup check>
            <Label check>
              <Input
                type="checkbox"
                checked={editIsTaxable}
                onChange={(e) => setEditIsTaxable(e.target.checked)}
                disabled={isUpdating}
              />
              {t("is_taxable")}
            </Label>
          </FormGroup>
        </ModalBody>
        
        <ModalFooter>
          <Button
            type="submit"
            color="primary"
            disabled={isUpdating || !editAmount || !editStartDate}
            className="me-2"
          >
            {isUpdating ? (
              <>
                <i className="fa fa-spinner fa-spin me-2"></i>
                {t("updating")}...
              </>
            ) : (
              <>
                <i className="fa fa-save me-2"></i>
                {t("update")}
              </>
            )}
          </Button>
          <Button color="secondary" onClick={toggle} disabled={isUpdating}>
            <i className="fa fa-times me-2"></i>
            {t("cancel")}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default EditBonusModal;